import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ContactForm from './components/ContactForm';

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-20 pb-16">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <Breadcrumb items={[
            { label: '首页', path: '/' },
            { label: '关于我们' },
          ]} />

          <header className="mb-12 text-center">
            <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary-500/10 mx-auto mb-5">
              <i className="ri-spy-line text-3xl text-primary-400"></i>
            </div>
            <h1 className="text-3xl md:text-4xl font-black text-foreground-50 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
              关于黑网料
            </h1>
            <p className="text-foreground-500 max-w-2xl mx-auto leading-relaxed">
              穿透信息迷雾，洞察真相背后。黑网料致力于为公众提供被主流渠道忽视的深度内幕资讯。
            </p>
          </header>

          <section className="mb-16">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div className="p-6 rounded-xl bg-background-900 border border-background-800/60">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 mb-4">
                  <i className="ri-lightbulb-line text-xl text-primary-400"></i>
                </div>
                <h2 className="text-xl font-bold text-foreground-100 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                  我们的使命
                </h2>
                <p className="text-foreground-400 leading-relaxed text-sm mb-3">
                  在信息爆炸的时代，真正有价值的内幕资讯往往被淹没在噪音之中，或被刻意隐藏。黑网料的使命是穿透层层信息壁垒，为公众挖掘和呈现被删除、被屏蔽的第一手深度内容。
                </p>
                <p className="text-foreground-400 leading-relaxed text-sm">
                  我们相信，信息的自由流通是社会进步的基石。每一个被隐藏的真相，都值得被揭示；每一个被压制的聲音，都值得被倾听。
                </p>
              </div>
              <div className="p-6 rounded-xl bg-background-900 border border-background-800/60">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10 mb-4">
                  <i className="ri-shield-check-line text-xl text-accent-400"></i>
                </div>
                <h2 className="text-xl font-bold text-foreground-100 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                  我们的原则
                </h2>
                <ul className="space-y-3 text-sm text-foreground-400">
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-accent-400 mt-0.5 shrink-0"></i>
                    <span><strong className="text-foreground-300">真实性优先：</strong>所有资讯均经过多源交叉验证，杜绝虚假信息和谣言传播。</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-accent-400 mt-0.5 shrink-0"></i>
                    <span><strong className="text-foreground-300">来源保护：</strong>严格保护信息提供者的隐私和安全，绝不泄露任何信源身份。</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-accent-400 mt-0.5 shrink-0"></i>
                    <span><strong className="text-foreground-300">合法合规：</strong>严格遵守中国法律法规，在保障公众知情权的同时维护国家安全和社会稳定。</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-accent-400 mt-0.5 shrink-0"></i>
                    <span><strong className="text-foreground-300">独立客观：</strong>保持编辑独立性，不接受任何形式的有偿删稿或利益输送。</span>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-2xl font-bold text-foreground-100 mb-8 text-center" style={{ fontFamily: "var(--font-heading)" }}>
              平台信誉
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
              {[
                { value: '5年+', label: '持续运营', icon: 'ri-timer-line' },
                { value: '12,860+', label: '收录资讯', icon: 'ri-article-line' },
                { value: '3,200+', label: '独家内容', icon: 'ri-vip-crown-line' },
                { value: '890万+', label: '月阅读量', icon: 'ri-bar-chart-line' },
              ].map((stat) => (
                <div key={stat.label} className="p-5 rounded-xl bg-background-900 border border-background-800/60 text-center">
                  <i className={`${stat.icon} text-2xl text-primary-400 mb-3 block`}></i>
                  <div className="text-2xl font-black text-foreground-100 mb-1" style={{ fontFamily: "var(--font-heading)" }}>{stat.value}</div>
                  <div className="text-xs text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-2xl font-bold text-foreground-100 mb-2 text-center" style={{ fontFamily: "var(--font-heading)" }}>
              编辑团队
            </h2>
            <p className="text-foreground-500 text-sm text-center mb-8">
              黑网料拥有一支专业的调查编辑团队，由资深媒体人、前调查记者和网络安全专家组成。
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {[
                { name: '深喉调查员', role: '首席调查编辑', desc: '前主流媒体调查记者，拥有15年深度报道经验，擅长政经领域的暗线追踪。', icon: 'ri-user-star-line' },
                { name: '暗网观察员', role: '技术情报分析师', desc: '网络安全专家，精通暗网信息搜集与数据挖掘，负责技术类内幕的交叉验证。', icon: 'ri-terminal-box-line' },
                { name: '财经调查组', role: '财经调查团队', desc: '由多名前投行分析师和财经记者组成，专注金融资本领域的黑幕调查。', icon: 'ri-funds-line' },
                { name: '暗访调查组', role: '实地调查团队', desc: '拥有丰富的暗访调查经验，深入一线获取第一手证据材料，曝光社会黑幕。', icon: 'ri-camera-line' },
              ].map((member) => (
                <div key={member.name} className="p-5 rounded-xl bg-background-900 border border-background-800/60">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-500/10 mb-3">
                    <i className={`${member.icon} text-xl text-secondary-400`}></i>
                  </div>
                  <h3 className="text-base font-bold text-foreground-200 mb-1">{member.name}</h3>
                  <p className="text-xs text-foreground-500 mb-2">{member.role}</p>
                  <p className="text-xs text-foreground-600 leading-relaxed">{member.desc}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-2xl font-bold text-foreground-100 mb-8 text-center" style={{ fontFamily: "var(--font-heading)" }}>
              常见问题
            </h2>
            <div className="space-y-3 max-w-2xl mx-auto">
              {[
                { q: '黑网料的信息来源是什么？', a: '我们的信息来源包括公开网络信息、暗网存档内容、用户投稿以及调查团队的独立调查成果。所有信息均经过多方交叉验证。' },
                { q: '如何保证信息的真实性？', a: '我们采用多源交叉验证机制，每条信息至少经过两个独立来源的确认才会发布。对于无法完全验证的信息，我们会明确标注"待核实"。' },
                { q: '我可以投稿吗？', a: '当然可以。我们欢迎知情人士提供有价值的线索和证据。请通过本页底部的联系表单与我们取得联系，我们将严格保护您的隐私。' },
                { q: '黑网料是否合法？', a: '黑网料严格遵守中华人民共和国法律法规。我们致力于在合法的框架内，最大限度地保障公众的知情权。' },
              ].map((faq, index) => (
                <details key={index} className="group p-5 rounded-xl bg-background-900 border border-background-800/60 cursor-pointer">
                  <summary className="flex items-center justify-between text-foreground-200 font-semibold text-sm">
                    {faq.q}
                    <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform duration-200"></i>
                  </summary>
                  <p className="mt-3 text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                </details>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground-100 mb-8 text-center" style={{ fontFamily: "var(--font-heading)" }}>
              联系我们
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div className="space-y-4">
                {[
                  { icon: 'ri-mail-line', label: '投稿/爆料', value: 'tips@heiwangliao.com' },
                  { icon: 'ri-shield-keyhole-line', label: '安全联系（PGP）', value: '6A2F 8C3D 9E1B 4F7A' },
                  { icon: 'ri-telegram-line', label: 'Telegram 频道', value: '@heiwangliao_tips' },
                  { icon: 'ri-wechat-line', label: '微信公众号', value: '黑网料内参' },
                ].map((contact) => (
                  <div key={contact.label} className="flex items-center gap-4 p-4 rounded-lg bg-background-900 border border-background-800/60">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 shrink-0">
                      <i className={`${contact.icon} text-lg text-primary-400`}></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-600 mb-0.5">{contact.label}</p>
                      <p className="text-sm text-foreground-300 font-mono">{contact.value}</p>
                    </div>
                  </div>
                ))}
              </div>
              <ContactForm />
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}